import { Component, inject } from '@angular/core';
import { NurseryActivityQualityControlService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  NurseryActivityQualityControlCreateDto,
  NurseryActivityQualityControlDto,
  NurseryActivityQualityControlExcelDownloadDto,
  NurseryActivityQualityControlUpdateDto,
} from '../proxy/controlling/dtos/nursery-activity-quality-control';
import { NURSERYACTIVITYQUALITYCONTROL_CONFIG, NURSERYACTIVITYQUALITYCONTROL_FIELDS } from './nursery-activity-quality-control.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nursery-activity-quality-control',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, NurseryActivityQualityControlService, ConfirmationService],
  templateUrl: './nursery-activity-quality-control.html',
  styleUrl: './nursery-activity-quality-control.scss',
})
export class NurseryActivityQualityControl extends BaseHierarchicalCrudComponent<
  NurseryActivityQualityControlDto,
  NurseryActivityQualityControlCreateDto,
  NurseryActivityQualityControlUpdateDto,
  NurseryActivityQualityControlExcelDownloadDto
> {
  service = inject(NurseryActivityQualityControlService);
  config = NURSERYACTIVITYQUALITYCONTROL_CONFIG;
  fields = NURSERYACTIVITYQUALITYCONTROL_FIELDS;

  protected prepareUpdateDto(data: any, selected: NurseryActivityQualityControlDto): NurseryActivityQualityControlUpdateDto {
    return {
      nurseryActivityParameterId: data.nurseryActivityParameterId,
      qualityControlId: data.qualityControlId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'NurseryActivityQualityControl';
  }
}
